import type { UserWalletNested } from '@infinex/types';
import { getWalletsV2MainWallet } from '@infinex/types';
import type { GenericDatasetState } from '@infinex/user';
import { useMappedDataset } from '@infinex/user';

/**
 * @return The main/original wallet (Turnkey operation wallet, index 0)
 */
export function useWalletsV2MainWallet(): GenericDatasetState<UserWalletNested | null> {
  return useMappedDataset('walletsV2', getWalletsV2MainWallet);
}
